import global from "@/locales/fr-BE/global";
import error403 from "@/locales/fr-BE/errors/403";
import error404 from "@/locales/fr-BE/errors/404";
import error500 from "@/locales/fr-BE/errors/500";
import error503 from "@/locales/fr-BE/errors/503";
import error504 from "@/locales/fr-BE/errors/504";
import maintenance from "@/locales/fr-BE/auth/maintenance";
import toast from "@/locales/fr-BE/toast/toast";
import login from "@/locales/fr-BE/auth/login";
import onboarding from "@/locales/fr-BE/auth/onboarding";
import loginPageSteps from "@/locales/fr-BE/loginPageSteps";
import dashboard from "@/locales/fr-BE/dashboard/dashboard";
import account from "@/locales/fr-BE/account/account";
import mailbox from "@/locales/fr-BE/account/mailbox";
import bankstatement from "@/locales/fr-BE/account/bankstatement";
import myApps from "@/locales/fr-BE/my-apps/myApps";
import about from "@/locales/fr-BE/about/about";
import contactService from "@/locales/fr-BE/about/contactService";
import salesPromotions from "@/locales/fr-BE/sales/promotions";
import brochures from "@/locales/fr-BE/sales/brochures";
import shop from "@/locales/fr-BE/shop/data";
import priceList from "@/locales/fr-BE/shop/priceList";
import staff from "@/locales/fr-BE/dashboard/staff";
import promotions from "@/locales/fr-BE/promotions";
import points from "@/locales/fr-BE/points";
import trainings from "@/locales/fr-BE/trainings/trainings";
import vouchers from "@/locales/fr-BE/vouchers/vouchers";
import generateReport from "@/locales/fr-BE/generate-report/generateReport";
import widgets from "@/locales/fr-BE/widgets/widgets";
import wholesaler from "@/locales/fr-BE/wholesaler/wholesaler";
import media from "@/locales/fr-BE/media/index";
import product from "@/locales/fr-BE/product";
import message from "@/locales/fr-BE/message/index";
import commitmentLetter from "@/locales/fr-BE/account/commitmentLetter";
import multiplicator from "@/locales/fr-BE/multiplicator";
import consents from "@/locales/fr-BE/consents/consents";
import investment from "@/locales/fr-BE/investment/data";
import kickback from "@/locales/fr-BE/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  generateReport: generateReport.messages,
  widgets: widgets.messages,
  wholesaler: wholesaler.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  kickbackInfo: { withdraw: "Pour le versement de la prime" },
  productBrochures: {
    BDriveTitle: "Images de produits",
    BDriveLinkText: "Lien vers le portail IMAGES PRODUITS",
  },
}

export default {
  locale: "fr-BE",
  messages,
};
